export const COLORS = {
  GREY: 'grey',
  SUCCESS: 'success',
  INFO: 'info',
  ERROR: 'error',
  INHERIT: 'inherit',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  WARNING: 'warning'
};
